/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 1/11/15
 * Time: 3:25 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Config = require("personalization-web-agent-config/config.json");
    var Template = require("personalization-web-agent-templates/clickToDummyEngagementAnchor.tmpl");

    var BaseAnchorView = require("personalization-views/BaseAnchorView");

    var ClickToDummyEngagementAnchorView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        ClickToDummyEngagementAnchorView = BaseAnchorView.extend({
            className: "click-to-dummy-engagement-anchor anchor",
            template: Template,
            withUIComponents: true,
            events:{
                "click":"_onClick"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("Initializing ClickToDummyEngagementAnchorView", "ClickToDummyEngagementAnchorView:initialize");
                BaseAnchorView.prototype.initialize.call(this, options);
            },

            onRender: function () {
                LEPersonalization.logger.debug("Rendering ClickToDummyEngagementAnchorView", "ClickToDummyEngagementAnchorView:onRender");
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing ClickToDummyEngagementAnchorView", "ClickToDummyEngagementAnchorView:onClose");
            },

            /************************** Utility private functions that does not need "this" ********************/
            _onClick:function(){
                LEPersonalization.loader.setLoader();

                LEPersonalization.navigateToPageMenu({
                    module:"LEWebAgent",
                    page: Config.SIMULATED_ENGAGEMENT_PAGE
                });

                LE.vent.once(LE.mediaCodes.webAgent.vent.widgetsAreaVisible, function(){
                    LEPersonalization.loader.closeLoader();
                });
            }
        });
    });
    return ClickToDummyEngagementAnchorView;
});


